import React, { useState } from 'react';
import Button from '../Button';
import { CARRIER_LABELS, SHIPMENT_STATUSES } from '../../constants/shipments';
import Dialog from './Dialog';
import EntityPicker from './EntityPicker';
import { SelectField, TextField } from './FormFields';

const TEXT_KEYS = ['trackingNumber', 'orderRef', 'expectedDelivery', 'deliveredAt', 'status', 'carrierCode'];
const ID_KEYS = ['customerId', 'supplierId'];

// Small correction form before approving a review item. Only filled fields become `corrections`.
const ReviewApproveDialog = ({ onClose, onSubmit, busy }) => {
  const [form, setForm] = useState({ status: '', carrierCode: '', trackingNumber: '', orderRef: '', expectedDelivery: '', deliveredAt: '', customerId: '', supplierId: '' });
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));
  const setId = (key) => (id) => setForm((f) => ({ ...f, [key]: id }));

  const submit = (e) => {
    e.preventDefault();
    const corrections = {};
    TEXT_KEYS.forEach((k) => { const v = form[k].trim(); if (v) corrections[k] = v; });
    ID_KEYS.forEach((k) => { if (form[k]) corrections[k] = Number(form[k]); });
    onSubmit(corrections);
  };

  return (
    <Dialog
      title="Opravit a schválit" wide busy={busy} onClose={onClose}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>Zrušit</Button>
          <Button type="submit" form="shp-approve-form" loading={busy}>Schválit s opravou</Button>
        </>
      )}
    >
      <form id="shp-approve-form" onSubmit={submit} noValidate>
        <p className="shp-muted" style={{ fontSize: 14, margin: '0 0 14px' }}>
          Vyplňte jen to, co chcete změnit. Opravená pole se uloží jako ruční a synchronizace je už nepřepíše.
        </p>
        <div className="shp-grid2">
          <SelectField label="Stav" value={form.status} onChange={set('status')} placeholder="Beze změny" options={SHIPMENT_STATUSES.map((s) => ({ value: s.value, label: s.label }))} />
          <SelectField label="Dopravce" value={form.carrierCode} onChange={set('carrierCode')} placeholder="Beze změny" options={Object.entries(CARRIER_LABELS).map(([value, label]) => ({ value, label }))} />
          <TextField label="Číslo zásilky" value={form.trackingNumber} onChange={set('trackingNumber')} maxLength={80} autoComplete="off" />
          <TextField label="Číslo objednávky" value={form.orderRef} onChange={set('orderRef')} maxLength={80} autoComplete="off" />
          <TextField label="Očekávané doručení" type="date" value={form.expectedDelivery} onChange={set('expectedDelivery')} />
          <TextField label="Doručeno dne" type="date" value={form.deliveredAt} onChange={set('deliveredAt')} />
          <EntityPicker kind="customer" label="Zákazník" value={form.customerId} onChange={setId('customerId')} />
          <EntityPicker kind="supplier" label="Dodavatel" value={form.supplierId} onChange={setId('supplierId')} />
        </div>
      </form>
    </Dialog>
  );
};

export default ReviewApproveDialog;
